import sanitizeHtml from "sanitize-html";
import { marked, Marked, RendererObject } from "marked";
import parse from "html-react-parser";

const sanitizeOptions: sanitizeHtml.IOptions = {
  allowedTags: ["b", "i", "em", "strong", "a", "s", "span", "br"],
  allowedAttributes: {
    a: ["href"]
  },
  allowedClasses: {
    "*": ["*"]
  }
};

function postprocess(html: any) {
  return sanitizeHtml(html, { ...sanitizeOptions });
}

// Create a singleton marked instance to avoid global state mutations
let markedInstance: any = null;

function getMarkedInstance() {
  if (!markedInstance) {
    markedInstance = new Marked({
      hooks: { postprocess },
      async: false
    });
  }
  return markedInstance;
}

export const parseMDContent = (content: string, options?: { renderer?: RendererObject }) => {
  if (!content) return null;

  try {
    const instance = getMarkedInstance();

    // Apply renderer if provided, but don't mutate the global instance
    if (options?.renderer) {
      const tempInstance = new Marked({
        hooks: { postprocess },
        renderer: options.renderer,
        async: false
      });
      const converted = tempInstance.parse(content) as string;
      const parsedHtml = parse(converted);
      return parsedHtml;
    }

    const converted = instance.parse(content) as string;
    const parsedHtml = parse(converted);

    return parsedHtml;
  } catch (error) {
    console.error("Markdown parsing error:", error);
    // Return sanitized fallback content
    const sanitizedContent = sanitizeHtml(content, sanitizeOptions);
    return parse(sanitizedContent);
  }
};
